import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import dayjs from "dayjs";
import DataTable from "react-data-table-component";

//internal import
import PageHeader from "../../components/common/PageHeader";
import useStoreSubmit from "../../hooks/useStoreSubmit";
import InputArea from "../../components/Input/InputArea";
import Error from "../../components/Input/Error";
import ModalLoading from "../../components/Loading/ModalLoading";
import useAsync from "../../hooks/useAsync";
import StoreService from "../../services/StoresService";
import Uploader from "../../components/imageuploader/Uploader";

function Stores() {

    const [storeId, setStoreId] = useState("");
    const { data, loading } = useAsync(() => StoreService.getAllStore());

    const {
        register,
        handleSubmit,
        errors,
        onSubmit,
        handleDeleteStore,
        isModal,
        setIsModal,
        isViewModal,
        setIsViewModal,
        isDeleteModal,
        setIsDeleteModal,
        imageUrl,
        setImageUrl,
        viewData } = useStoreSubmit(storeId);

    var addPermission = 1;
    var viewPermission = 1;
    var editPermission = 1;
    var deletePermission = 1;
    var listPermission = 1;

    const columnT = [
        {
            name: "NAME",
            selector: (row) => row.name,
            sortable: true,
            cell: (row) => <b>{row.name}</b>
        },
        {
            name: "DOMAIN",
            selector: (row) => row.domain,
            sortable: true
        },
        {
            name: "EMAIL",
            selector: (row) => row.email,
            minWidth: "250px",
            sortable: true
        },
        {
            name: "PHONE",
            selector: (row) => row.phone,
            minWidth: "250px",
            sortable: true
        },
        {
            name: "CREATION DATE",
            selector: (row) => dayjs(row.createdAt).format("DD-MM-YYYY"),
            sortable: true
        },
        {
            name: "ACTION",
            selector: (row) => { },
            sortable: true,
            minWidth: "150px",
            cell: (row) => (<div className="btn-group" role="group" aria-label="Basic outlined example">
                {(viewPermission === 1) && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsViewModal(true); setStoreId(row?._id) }} ><i className="icofont-eye-alt text-primary"></i></button>)}
                {(editPermission === 1) && (<button type="button" className="btn btn-outline-secondary" onClick={() => { setIsModal(true); setStoreId(row?._id); }}><i className="icofont-edit text-success"></i></button>)}
                {(deletePermission === 1) && (<button type="button" className="btn btn-outline-secondary deleterow" onClick={() => { setIsDeleteModal(true); setStoreId(row?._id) }} ><i className="icofont-ui-delete text-danger"></i></button>)}
            </div>)
        }

    ]

    return (
        <div className="container-xxl">
            {loading ? <ModalLoading loading={loading} /> :
                <>
                    <PageHeader headerTitle="Stores" addPermission={addPermission} renderRight={() => {
                        return <div className="col-auto d-flex w-sm-100">
                            <button className="btn btn-dark btn-set-task w-sm-100 me-2" onClick={() => { setIsModal(true); setStoreId(""); }}><i className="icofont-plus-circle me-2 fs-6"></i>Add Store</button>
                        </div>
                    }} />

                    <div className="container-xxl">
                        <div className="row clearfix g-3">
                            <div className="col-md-12">
                                {listPermission === 1 && (
                                    <div className="card">
                                        <div className="card-body">
                                            <DataTable
                                                title={"Store List"}
                                                columns={columnT}
                                                data={data?.data}
                                                defaultSortField="title"
                                                pagination
                                                selectableRows={false}
                                                className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                                highlightOnHover={true}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </>
            }

            {/* store view modal */}
            <Modal show={isViewModal} size="lg" centered onHide={() => { setIsViewModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Store Detail</Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <div className="modal-body">
                        <div className="deadline-form">
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Store Logo </b>
                                </div>
                                <div className="col-sm-6">
                                    {viewData?.logo ? (
                                        <img src={viewData?.logo} alt="store" style={{ height: "200px", width: "200px" }} className="h-64 w-64" crossOrigin="anonymous" />
                                    ) : (
                                        <img
                                            src="https://res.cloudinary.com/ahossain/image/upload/v1655097002/placeholder_kvepfp.png"
                                            alt="slider"
                                            crossOrigin="anonymous"
                                        />
                                    )}
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Store Name </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.name}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Domain </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.domain}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Email </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.email}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b>Phone</b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.phone}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Address </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.address}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Postal Code </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.zipcode || "-"}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Country </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.country || "-"}</div>
                                </div>
                            </div>
                            <div className="row g-3 mb-3">
                                <div className="col-sm-6">
                                    <b> Status </b>
                                </div>
                                <div className="col-sm-6">
                                    <div>{viewData?.status || "-"}</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            {/* Store add and edit modal */}
            <Modal size="lg" centered show={isModal} onHide={() => { setIsModal(false); }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">{storeId ? "Update " : "Add"} Store</Modal.Title>
                </Modal.Header>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Body>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput877" className="form-label">Store Name</label>
                                <InputArea register={register} name="name" label={"Store Name"} type="text" className="form-control" id="exampleFormControlInput877" placeholder="Store Name" />
                                <Error errorName={errors?.name} />
                            </div>
                            <div className="mb-3">
                                <label htmlFor="exampleFormControlInput977" className="form-label">Domain Name</label>
                                <InputArea register={register} name="domain" label={"Domain Name"} type="text" className="form-control" id="exampleFormControlInput977" placeholder="Domain Name" />
                                <Error errorName={errors?.domain} />
                            </div>
                            <div className="deadline-form">
                                <div className="row g-3 mb-3">
                                    <div className="col-lg-6">
                                        <label htmlFor="exampleFormControlInput477" className="form-label">Email ID</label>
                                        <InputArea register={register} name="email" label={"Email"} type="email" className="form-control" id="exampleFormControlInput477" placeholder="Enter Email" />
                                        <Error errorName={errors?.email} />
                                    </div>

                                    <div className="col-lg-6">
                                        <label htmlFor="exampleFormControlInput777" className="form-label">Phone</label>
                                        <InputArea register={register} name="phone" label={"Phone"} type="text" className="form-control" id="exampleFormControlInput777" placeholder="Enter Phone" />
                                        <Error errorName={errors?.phone} />
                                    </div>
                                    <div className="col-lg-6">
                                        <label htmlFor="exampleFormControlInput87711" className="form-label">Address</label>
                                        <InputArea register={register} name="address" label={"Address"} type="text" className="form-control" id="exampleFormControlInput87711" placeholder="Address" />
                                        <Error errorName={errors?.address} />
                                    </div>
                                    <div className="col-lg-6">
                                        <label htmlFor="exampleFormControlInput87712" className="form-label">Postal Code</label>
                                        <InputArea register={register} name="zipcode" label={"Postal Code"} type="text" className="form-control" id="exampleFormControlInput87712" placeholder="Postal Code" />
                                        <Error errorName={errors?.zipcode} />
                                    </div>
                                    <div className="col-lg-6">
                                        <label htmlFor="departmentId" className="form-label">Country</label>
                                        <select className="form-select"
                                            name="status"
                                            {...register(`country`, {
                                                required: `Country is required!`,
                                            })}
                                        >
                                            <option value="">Select Country</option>
                                            <option value="Singapore">Singapore</option>
                                        </select>
                                        <Error errorName={errors?.country} />
                                    </div>
                                    <div className="col-lg-6">
                                        <label className="form-label">Logo</label>
                                        <Uploader
                                            imageUrl={imageUrl}
                                            setImageUrl={setImageUrl}
                                            folder="slider"
                                            name="logo"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-secondary" onClick={() => { setIsModal(false) }}>Cancel</button>
                        <button type="submit" className="btn btn-primary">{storeId ? "Update " : "Add"}</button>
                    </Modal.Footer>
                </form>
            </Modal>

            {/* Store delete modal */}
            <Modal show={isDeleteModal} centered onHide={() => { setIsDeleteModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title className="fw-bold">Delete Store</Modal.Title>
                </Modal.Header>
                <Modal.Body className="justify-content-center flex-column d-flex">
                    <i className="icofont-ui-delete text-danger display-2 text-center mt-2"></i>
                    <p className="mt-4 fs-5 text-center">Are You Sure! Want to Delete Store ?</p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => { setIsDeleteModal(false) }}>Cancel</button>
                    <button type="button" className="btn btn-danger color-fff" onClick={() => handleDeleteStore(storeId)}>Delete</button>
                </Modal.Footer>
            </Modal>

        </div >

    )
}


export default Stores;